








































































import { Component, Vue } from 'vue-property-decorator';
let bulmaCarousel = require( 'bulma-extensions/bulma-carousel/dist/js/bulma-carousel.min.js' );

@Component
export default class Home extends Vue
{
    mounted()
    {
        bulmaCarousel.attach();
    }
}
